import { FC } from 'react'
import { useRecoilValue } from 'recoil'
import * as userListsModalAtoms from 'src/atoms/user-lists/user-lists-modal'
import { UserLists } from 'src/components/user-lists-modal/user-lists'
import { UserListItems } from 'src/components/user-lists-modal/user-list-items'

export const UserListsContent: FC = () => {
  const selectedList = useRecoilValue(userListsModalAtoms.selectedList)

  const List = selectedList ? UserListItems : UserLists

  return <List />
}
